import { GET_LAMPS_FAIL, GET_LAMPS_SUCCESS } from "./actionTypes"

const INIT_STATE = {
  lamps: {},
  error: {},
}

const Lamp = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LAMPS_SUCCESS:
      return {
        ...state,
        lamps: action.payload,
      }

    case GET_LAMPS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Lamp
